import { delete_good, list_good, create_good, data_good, pay, list_order, withdraw, getUrl } from '@/api/good';
import config from "@/config";
import { deepClone, getFormatDate, getParentArea } from "@/common/utils";
import { _get, _post } from "@/api";
const currentDate = new Date().getTime();
export default {
  namespaced: true,
  actions: {
    // 获取商品列表
    getGoodList({ state, commit }: any, data: any) {
      return new Promise((resolve, reject): any => {
        return list_good(data)
          .then((res: any) => {
            const { code, data, msg } = res.data;
            if (code === 0) {
              const records = data;
              records.map((item: any) => {
                const baseURL =
                  process.env.NODE_ENV === "development"
                    ? config.basicUrl
                    : `${location.origin}/`;
                let src = `${baseURL}zst/user/file/getPathToStream?pathUrl=${item.imagesUrl ? item.imagesUrl.split(",")[0] : item.imagesUrl
                  }`;
                item.imagesUrl = src;
                const beginDate = item.discountStartTime
                  ? new Date(item.discountStartTime).getTime()
                  : null;
                const endDate = item.discountStopTime
                  ? new Date(item.discountStopTime).getTime()
                  : null;
                if (
                  (beginDate ? currentDate >= beginDate : false) &&
                  (endDate ? currentDate <= endDate : true)
                ) {
                  item.price = (item.discount || 1) * item.price;
                }
                item.storageTime = item.storageTime
                  ? getFormatDate(item.storageTime)
                  : null;
                return item;
              });
              resolve(records);
            } else {
              reject(msg);
            }
          })
      })
    },
    updateGood({ state, commit }: any, data: any) {
      const req = {
        data,
        url: 'zst/servicePlatform/updateOrderStatus'
      }
      return _get(req).then(res => res.data);
    },
    getGoodUrl({ state, commit }: any, url: any) {
      return getUrl(url)
        .then((res: any) => { return res.data.data })
        .catch((e: string) => console.error(e))
    },
    // 获取订单列表
    async getOrderList({ state, commit }: any, data: any) {
      const res: any = await list_order(data)
        .then((res: any) => { return res.data })
        .catch((e: string) => console.error(e))
      return res;
    },
    // 退款
    async withdraw({ state, commit }: any, data: any) {
      const res: any = await withdraw(data)
        .then((res: any) => { return res.data })
        .catch((e: string) => console.error(e))
      return res;
    },
    async deleteOrder({ state, commit }: any, data: any) {
      const res: any = await delete_good(data)
        .then((res: any) => { return res.data })
        .catch((e: string) => console.error(e))
      return res;
    },
    // 获取商品信息
    async getGoodData({ state, commit }: any, data: any) {
      const res: any = await data_good(data)
        .then((res: any) => { return res.data })
        .catch((e: string) => console.error(e))
      return res;
    },
    // 创建商品订单
    async createGoodData({ state, commit }: any, data: any) {
      const res: any = await create_good(data)
        .then((res: any) => { return res.data })
        .catch((e: string) => console.error(e))
      return res;
    },
    // 创建商品订单
    async pay({ state, commit }: any, data: any) {
      const res: any = await pay(data)
        .then((res: any) => { return res })
        .catch((e: string) => console.error(e))
      return res;
    },
  }
}